export const WHEEL_CONFIG = {
  canvasSize: 650,
  friction: 0.991,
  spinSpeedMin: 0.25,
  spinSpeedMax: 0.45,
  stopThreshold: 0.002,
  font: 'bold 30px sans-serif',
  labelColor: '#ffffff',
  spinDurationMs: 5200,
};

export const APP_DEFAULTS = {
  brandName: 'Alyf',
  loaderDelay: 2000,
  firestoreCollection: 'organisation',
  firestoreConfigCollection: 'config',
  firestoreConfigId: 'app',
  firestoreEntriesCollection: 'entries',
  firestoreSpinsCollection: 'spins',
  spinPromptLabel: 'Spin The Wheel to Win a Prize',
  primaryColor: '#F3BB1A',
  accentColor: '#FFD700',
  winMessage: 'Congratulations {name}! You won: {prize}',
  failMessage: 'Sorry {name}, better luck next time.',
  accountRequiredMessage: 'Veuillez creer un compte avant de jouer.',
  taglines: [
    'Where Every Spin Sparks Joy!',
    'Wheel Brings Gifts Galore!',
    "Alyf's Wheel of Rewards!",
  ],
  carouselInterval: 10000,
  maxSpinsPerUser: 1,
  formFields: ['phone'] as string[],
  countdownTargetDate: 0,
  campaignEnabled: true,
  campaignEndsAt: null as number | null,
  allowLocalTimerOverride: false,
  logoUrl: '',
  homeWheelCenterImageUrl: '',
};

export interface AppConfig {
  brandName: string;
  loaderDelay: number;
  spinPromptLabel: string;
  primaryColor: string;
  accentColor: string;
  winMessage: string;
  failMessage: string;
  accountRequiredMessage: string;
  taglines: string[];
  carouselInterval: number;
  maxSpinsPerUser: number;
  formFields: string[];
  countdownTargetDate: number;
  campaignEnabled: boolean;
  campaignEndsAt: number | null;
  allowLocalTimerOverride: boolean;
  logoUrl: string;
  homeWheelCenterImageUrl: string;
}
